module.exports = __webpack_public_path__ + "static/media/w (5).2d0482a1.jpg";